'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isLastWeek.js
// module id = 545
// module chunks = 0